// This replaces the PickersActionBar on DateTime components. The "today" action
// rounds the current time up to the next 5 minute increment instead of using
// the exact current time. All other actions are default used.

import DialogActions from '@mui/material/DialogActions';
import {
  usePickerContext,
  usePickerTranslations,
} from '@mui/x-date-pickers/hooks';
import { PickersActionBarProps } from '@mui/x-date-pickers/PickersActionBar';

import { Button } from '@atom/mui';
import {
  convertMinutesToMilliseconds,
  roundUpByMilliseconds,
} from '@atom/utilities/timeUtilities';

const FIVE_MINUTES_IN_MILLISECONDS = convertMinutesToMilliseconds(5);

export const DateTimePickerActionBar = (props: PickersActionBarProps) => {
  const { actions, ...other } = props;
  const translations = usePickerTranslations();
  const { clearValue, setValue, acceptValueChanges, cancelValueChanges } =
    usePickerContext();

  if (!actions || actions.length === 0) {
    return null;
  }

  const setValueToRoundedToday = () =>
    setValue(roundUpByMilliseconds(new Date(), FIVE_MINUTES_IN_MILLISECONDS), {
      source: 'view',
    });

  const buttons = actions.map(action => {
    switch (action) {
      case 'clear':
        return (
          <Button key={action} onClick={clearValue}>
            {translations.clearButtonLabel}
          </Button>
        );
      case 'cancel':
        return (
          <Button key={action} onClick={cancelValueChanges}>
            {translations.cancelButtonLabel}
          </Button>
        );
      case 'accept':
        return (
          <Button key={action} onClick={acceptValueChanges}>
            {translations.okButtonLabel}
          </Button>
        );
      case 'today':
        return (
          <Button key={action} onClick={setValueToRoundedToday}>
            {translations.todayButtonLabel}
          </Button>
        );
      default:
        return null;
    }
  });

  return <DialogActions {...other}>{buttons}</DialogActions>;
};
